import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "quickpay-pitch__text" }
const _hoisted_2 = { class: "quickpay-pitch__title typographies-display-brand-small" }
const _hoisted_3 = { class: "quickpay-pitch__description typographies-paragraph-medium-regular" }

import { inject } from 'vue';
import { Translator } from 'js/shims-vue';
import Card from 'vcomponents/common/card/Card.vue';

const illustrationSrc = '/ressources/logged/img/icon/svg/quickpay-pitch-illustration.svg';


export default /*@__PURE__*/_defineComponent({
  __name: 'QuickpaySettingsPitch',
  setup(__props) {

const $t = inject('$t') as Translator;

const translations: Record<string, string> = {
    title: $t.__('quickpay.settings.pitch.title'),
    description: $t.__('quickpay.settings.pitch.description'),
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Card, { class: "quickpay-pitch" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("p", _hoisted_2, _toDisplayString(translations.title), 1 /* TEXT */),
        _createElementVNode("p", _hoisted_3, _toDisplayString(translations.description), 1 /* TEXT */)
      ]),
      _createElementVNode("div", { class: "quickpay-pitch__preview" }, [
        _createElementVNode("img", {
          src: illustrationSrc,
          alt: "",
          class: "quickpay-pitch__illustration"
        })
      ])
    ]),
    _: 1 /* STABLE */
  }))
}
}

})